"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainFromURL = exports.isValidDomain = exports.getDomainFromEmail = exports.removeLabelFromEmail = exports.validateEmail = void 0;
const isemail_1 = require("isemail");
Object.defineProperty(exports, "validateEmail", { enumerable: true, get: function () { return isemail_1.validate; } });
const punycode = require("punycode");
const removeLabelFromEmail = (email) => {
    const indexOfPlus = email.indexOf("+");
    if (indexOfPlus && indexOfPlus !== -1) {
        const indexOfAt = email.indexOf("@");
        if (indexOfAt === -1 || !indexOfAt)
            return email;
        if (indexOfAt <= indexOfPlus)
            return email;
        return email.substring(0, indexOfPlus) + email.substring(indexOfAt);
    }
    return email;
};
exports.removeLabelFromEmail = removeLabelFromEmail;
const getDomainFromEmail = (email) => {
    if (!email)
        return;
    const emailArray = email === null || email === void 0 ? void 0 : email.split("@");
    if (!(emailArray === null || emailArray === void 0 ? void 0 : emailArray.length))
        return;
    return emailArray[emailArray.length - 1];
};
exports.getDomainFromEmail = getDomainFromEmail;
const getDomainFromURL = (domain) => {
    return domain
        .replace(/https?:\/\//, "")
        .replace("www.", "")
        .split("/")[0]
        .split("?")[0]
        .split("#")[0];
};
exports.getDomainFromURL = getDomainFromURL;
const isValidDomain = (domain) => {
    if (!domain)
        return false;
    const strippedDomain = getDomainFromURL(domain);
    // Regex from https://github.com/johno/domain-regex/blob/master/index.js
    const domainRegex = /\b((?=[a-z0-9-]{1,63}\.)(xn--)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\b/;
    if (strippedDomain && domainRegex.test(punycode.toASCII(strippedDomain))) {
        return true;
    }
    return false;
};
exports.isValidDomain = isValidDomain;
//# sourceMappingURL=email_helper.js.map